import { useRef, useEffect, useState } from "react";
import "../BuiltToGrow.css";
import girl_pen_on_battery from "../../../assets/girl_pen_on_battery.png";
import icon_tick from "../../../assets/icon_tick.png";
import builtBg from "../../../assets/built_bg_luxury_home.jpg";

export default function BuiltToGrow() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.2 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={sectionRef}
      className={`built-proven-brands-section ${inView ? "built-in-view" : ""}`}
      style={{ backgroundImage: `url(${builtBg})` }}
    >
      <div className="built-bg-overlay" />
      <div className="built-proven-brands-section-inner">
        <div className="built-brands-content">
          <div className="built-brands-info-card">
            <h2>Built to Grow with Your Home</h2>

            <div className="built-feature-row">
              <img src={icon_tick} alt="" className="built-feature-icon" />
              <p className="built-info-footer-list">
                SOFAR integrates <span className="built-highlight">advanced BMS, intelligent temperature control, and real-time monitoring</span>, to ensure stable and efficient performance.
              </p>
            </div>

            <div className="built-feature-row">
              <img src={icon_tick} alt="" className="built-feature-icon" />
              <p className="built-info-footer-list">
               Built with <span className="built-highlight">multi-level safety protection</span> and <span className="built-highlight">LiFePO4 battery technology</span> for reliable long-term operation.
              </p>
            </div>

            <div className="built-feature-row">
              <img src={icon_tick} alt="" className="built-feature-icon" />
              <p className="built-info-footer-list">
                <span className="built-highlight">Modular and expandable design</span> allows your system to grow with your energy needs while maintaining <span className="built-highlight">high efficiency and low self-consumption</span>.
              </p>
            </div>
          </div>

          <div className="built-brands-image-container">
            <img
              src={girl_pen_on_battery}
              alt="Home battery system"
              className="built-brands-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
